<template>
  <div class="stages-experts-modals">
    <v-modal name="expert-1" height="auto">
      <div class="stages-experts-modals__content">
        <rwl-heading h="3" v-html="$t('webinars.stages_experts_modals_1_name')"></rwl-heading>
        <rwl-heading h="4" v-html="$t('webinars.stages_experts_modals_1_position')"></rwl-heading>
        <p v-html="$t('webinars.stages_experts_modals_1_description')">

        </p>
      </div>
    </v-modal>
    <v-modal name="expert-2" height="auto">
      <div class="stages-experts-modals__content">
        <rwl-heading h="3" v-html="$t('webinars.stages_experts_modals_2_name')"></rwl-heading>
        <rwl-heading h="4" v-html="$t('webinars.stages_experts_modals_2_position')"></rwl-heading>
        <p v-html="$t('webinars.stages_experts_modals_2_description')">

        </p>
      </div>
    </v-modal>
    <v-modal name="expert-3" height="auto">
      <div class="stages-experts-modals__content">
        <rwl-heading h="3" v-html="$t('webinars.stages_experts_modals_3_name')"></rwl-heading>
        <rwl-heading h="4" v-html="$t('webinars.stages_experts_modals_3_position')"></rwl-heading>
        <p v-html="$t('webinars.stages_experts_modals_3_description')">

        </p>
      </div>
    </v-modal>
    <v-modal name="expert-4" height="auto">
      <div class="stages-experts-modals__content">
        <rwl-heading h="3" v-html="$t('webinars.stages_experts_modals_4_name')"></rwl-heading>
        <rwl-heading h="4" v-html="$t('webinars.stages_experts_modals_4_position')"></rwl-heading>
        <p v-html="$t('webinars.stages_experts_modals_4_description')">

        </p>
      </div>
    </v-modal>
  </div>
</template>

<script>
  import { RwlHeading } from "@rawlplug/rawlplug-design-components-library"
  // this component must be placed in the main app component
  // it use fixed position

  export default {
    name: "StagesExpertsModals",
    components: { RwlHeading }
  }
</script>

<style lang="scss">
  .stages-experts-modals {
    &__content {
      padding: $spacing-3 $spacing-4;
    }

    @media screen and (min-width: $breakpoint-sm-min) {
      &__content {
        padding: $spacing-6 $spacing-7;
      }
    }
  }

</style>
